<template>
  <div
    class="font-bold"
    v-if="
      isEdit ||
      (dispatchMission?.carriedJournalzz?.length ?? 0) > 0 ||
      (dispatchMission?.carriedMailzz?.length ?? 0) > 0 ||
      (dispatchMission?.carriedDispatchzz?.length ?? 0) > 0 ||
      (dispatchMission?.carriedMemoryzz?.length ?? 0) > 0
    "
  >
    <div
      :class="[
        'mx-4 font-bold flex items-center justify-between gap-2',
        extraClass,
      ]"
    >
      <div class="red-dot">
        {{ $t(`Chats.summary`) }}
      </div>
      <div class="flex-1">
        <div v-if="isEdit" class="flex-1 flex gap-2 flex-wrap justify-end">
          <SelectBackground
            title="选择前情"
            btn-class="btn-xs w-full  text-right btn-outline"
            :mate-id="leaderMate.id"
            :dispatch-mission="dispatchMission"
            v-model:journalzz="dispatchMission!.carriedJournalzz"
            v-model:mailzz="dispatchMission!.carriedMailzz"
            v-model:dispatchzz="dispatchMission!.carriedDispatchzz"
            v-model:memoryzz="dispatchMission!.carriedMemoryzz"
            :type-list="['journal', 'mail', 'dispatch', 'memory']"
            is-vertical
          />
        </div>
      </div>
    </div>

    <template v-if="dispatchMission?.carriedMailzz?.length">
      <p class="text-xs text-base-content/70 px-4 py-2">信件列表</p>

      <VanCellGroup inset>
        <VanCell
          v-for="mail in dispatchMission.carriedMailzz"
          :key="mail.id"
          :title="mail.subject"
        >
          <template #title>
            <div class="flex gap-1 justify-between">
              <div class="text-xs font-normal text-base-content/70 flex-1">
                <VanTextEllipsis
                  rows="1"
                  :content="removeHtmlTag(mail.body)"
                  :expand-text="$t(`Buttons.expand`)"
                  :collapse-text="$t(`Buttons.collapse`)"
                  @click-action.stop
                />
                <p class="line-clamp-1">{{ mail.subject }}</p>
              </div>
            </div>
          </template>
        </VanCell>
      </VanCellGroup>
    </template>

    <template v-if="dispatchMission?.carriedJournalzz?.length">
      <p class="text-xs text-base-content/70 px-4 py-2">手账列表</p>

      <VanCellGroup inset>
        <VanCell
          v-for="journal in dispatchMission.carriedJournalzz"
          :key="journal.id"
          :title="journal.date"
        >
          <template #title>
            <div class="flex gap-1 justify-between">
              <div class="text-xs font-normal text-base-content/70 flex-1">
                <VanTextEllipsis
                  rows="1"
                  :content="journal.content"
                  :expand-text="$t(`Buttons.expand`)"
                  :collapse-text="$t(`Buttons.collapse`)"
                  @click-action.stop
                />

                <p class="line-clamp-1">{{ journal.date }}</p>
              </div>
            </div>
          </template>
        </VanCell>
      </VanCellGroup>
    </template>

    <template v-if="dispatchMission?.carriedDispatchzz?.length">
      <p class="text-xs text-base-content/70 px-4 py-2">任务列表</p>

      <VanCellGroup inset>
        <VanCell
          v-for="dispatch in dispatchMission.carriedDispatchzz"
          :key="dispatch.id"
        >
          <template #title>
            <div
              class="flex gap-1 justify-between text-xs font-normal text-base-content/70"
            >
              <p>
                {{
                  dispatch.type === DispatchType.Mission
                    ? dispatch.mission?.name
                    : "溜达"
                }}
              </p>
              <p class="line-clamp-1 flex-1 text-right">
                {{ timeAgo(dispatch.dtCreate) }}
              </p>
            </div>
          </template>
        </VanCell>
      </VanCellGroup>
    </template>

    <template v-if="dispatchMission?.carriedMemoryzz?.length">
      <p class="text-xs text-base-content/70 px-4 py-2">场景记忆列表</p>
      <VanCellGroup inset>
        <VanCell
          v-for="memory in dispatchMission.carriedMemoryzz"
          :key="memory.id"
        >
          <template #title>
            <div
              class="flex gap-1 justify-between text-xs font-normal text-base-content/70"
            >
              <p>{{ memory.name }}</p>
            </div>
            <VanTextEllipsis
              rows="1"
              class="text-xs"
              :content="memory.text"
              :expand-text="$t(`Buttons.expand`)"
              :collapse-text="$t(`Buttons.collapse`)"
              @click-action.stop
            />
          </template>
        </VanCell>
      </VanCellGroup>
    </template>
  </div>
</template>

<script setup lang="ts">
import { Mate, MateDispatch } from "@/types/entity";
import { removeHtmlTag } from "@/tools/text";
import { DispatchType } from "@/enums/mission";
import { timeAgo } from "@/modules/common";
defineProps<{
  dispatchMission: MateDispatch;
  isEdit?: boolean;
  extraClass?: string;
  leaderMate: Mate;
}>();

// const isSame = (a: Entity[], b: Entity[]) => {
//   if (a.length !== b.length) return false;
//   const aMap = new Set(a.map((v) => v.id));
//   return b.every((v) => aMap.has(v.id));
// };

// const clickConfirm = async () => {
//   const dispatchMission = props.dispatchMission;
//   if (selectType.value === "journal") {
//     if (!isSame(includeJourney.value, dispatchMission.carriedJournalzz || [])) {
//       const pass = await checkAndInitObjective(props.dispatchMission);
//       if (!pass) return;
//     }

//     dispatchMission.carriedJournalzz = includeJourney.value;
//   } else if (selectType.value === "mail") {
//     if (!isSame(includeMail.value, dispatchMission.carriedMailzz || [])) {
//       const pass = await checkAndInitObjective(props.dispatchMission);
//       if (!pass) return;
//     }

//     dispatchMission.carriedMailzz = includeMail.value;
//   } else if (selectType.value === "dispatch") {
//     if (
//       !isSame(includeDispatch.value, dispatchMission.carriedDispatchzz || [])
//     ) {
//       const pass = await checkAndInitObjective(props.dispatchMission);
//       if (!pass) return;
//     }

//     dispatchMission.carriedDispatchzz = includeDispatch.value;
//   } else if (selectType.value === "memory") {
//     if (!isSame(includeMemory.value, dispatchMission.carriedMemoryzz || [])) {
//       const pass = await checkAndInitObjective(props.dispatchMission);
//       if (!pass) return;
//     }

//     dispatchMission.carriedMemoryzz = includeMemory.value;
//   }
//   showPopup.value = false;
// };
</script>
